import { Descriptor } from "hybrids";

export default function infiniteList<E, M>(
  fn: (host: E, page: number) => M[]
): Descriptor<E, Array<M[]>> {
  return {
    get(host, lastValue: Array<M[]>) {
      const result = lastValue.map((_, index) => fn(host, index + 1));
      result.toString = () => String(result.length);

      return result;
    },
    set(_, value, lastValue) {
      if (!value) return [null];

      if (lastValue && lastValue[lastValue.length - 1].length === 0) {
        return lastValue;
      }

      return Array(Number(value)).fill(null);
    },
  };
}

export function nextPage<E>(key: keyof E) {
  return (host: E) => {
    (host[key] as number) = (host[key] as []).length + 1;
  };
}
